module.exports = __webpack_public_path__ + "static/media/avatar1.322d5f86.jpg";